import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { LAB } from "@/data/lab";

// Slow editorial marquee — one long line, understated separators.
export default function EditorialMarquee() {
  const items = [
    "ISO Certified Laboratory",
    ...LAB.services,
    "Since 2010",
    "Jaysingpur",
  ];
  return (
    <section
      data-testid="editorial-marquee"
      className="border-y hair py-8 bg-white text-navy overflow-hidden"
    >
      <Marquee gradient={false} speed={35} pauseOnHover={false}>
        <div className="marquee-track">
          {items.map((it, i) => (
            <span key={i} className="flex items-center gap-14">
              <span className="font-display italic text-3xl md:text-5xl tracking-tight">
                {it}
              </span>
              <Asterisk className="h-6 w-6 md:h-8 md:w-8 text-cyan-brand" strokeWidth={1.5} />
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
